import { create } from 'zustand';

type State = {
    title: string | null;
};

type Actions = {
    setTitle: (title: string) => void;
    removeTitle: () => void;
};

export const useTitleStore = create<State & Actions>((set) => ({
    title: null,
    setTitle: (title: string) => set({ title }),
    removeTitle: () => set({ title: null }),
}));
